export default {"src":"/_next/static/media/mincifri.d6bb9a8e.svg","height":59,"width":57,"blurWidth":0,"blurHeight":0};